import { Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DateTime } from "luxon";

import { systemLabelsTxt } from "../../../../assets/texts/CloudAnalytics";
import SystemLabel from "./SystemLabel";

type Props = {
  reportCacheRefreshedAt: Date | undefined;
};

const CacheLastUpdated = ({ reportCacheRefreshedAt }: Props) => {
  const lastUpdated = reportCacheRefreshedAt ? DateTime.fromJSDate(reportCacheRefreshedAt) : undefined;

  return (
    <Grid
      container
      spacing={1}
      wrap="nowrap"
      sx={{
        columnGap: 1,
      }}
    >
      <SystemLabel label={systemLabelsTxt.CACHED.LABEL} tooltip={systemLabelsTxt.CACHED.TOOLTIP} />
      {lastUpdated?.isValid && (
        <>
          <Typography
            noWrap
            variant="body2"
            sx={{
              color: "text.secondary",
              fontWeight: 400,
              overflow: "initial",
              display: "flex",
              alignItems: "center",
              columnGap: 0.5,
              height: 20,
            }}
          >
            {`Last updated: `}
            <Tooltip title={lastUpdated.toFormat("dd LLL yyyy, HH:mm")} arrow>
              <Typography
                sx={{
                  textDecoration: "underline",
                  textDecorationStyle: "dotted",
                }}
              >
                {lastUpdated.toRelative()}
              </Typography>
            </Tooltip>
          </Typography>
        </>
      )}
    </Grid>
  );
};

export default CacheLastUpdated;
